module.exports = __webpack_public_path__ + "static/memory_img3M@2x-54c68a82813ec5e7d21dbe685ddc3093.png";